<h2 mat-dialog-title>Invoices/Delivery Notes </h2>
<h3 mat-dialog-title>Number :- {{ data.name }}</h3>
<div class="overlay-loader" *ngIf="isLoading">
  <div class="spinner-box">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
<mat-dialog-content>
    <div class="orders-container" *ngIf="attachments$ | async as file">
        <mat-card>
            <mat-card-content>
                <table mat-table [dataSource]="file" class="mat-elevation-z2 orders-table">
                    <ng-container matColumnDef="slno">
                        <th mat-header-cell *matHeaderCellDef> Sl No. </th>
                        <td mat-cell *matCellDef="let file; let i = index"> {{ i + 1 }} </td>
                    </ng-container>
                    <ng-container matColumnDef="file1_name">
                        <th mat-header-cell *matHeaderCellDef>Invoice</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file1_name }}
                            <button mat-icon-button color="primary"
                                (click)="downloadBase64File(file.file1, file.file1_name)">
                                <mat-icon>download</mat-icon>
                            </button>
                        </td>                        
                    </ng-container>
                     <ng-container matColumnDef="file1_status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file1_status }}                           
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file1_remarks">
                        <th mat-header-cell *matHeaderCellDef>Remarks</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file1_remarks }}                           
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file2_name">
                        <th mat-header-cell *matHeaderCellDef>Delivery Note / Completion Certificate</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file2_name }}
                            <button mat-icon-button color="accent"
                                (click)="downloadBase64File(file.file2, file.file2_name)">
                                <mat-icon>download</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                     <ng-container matColumnDef="file2_status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file2_status }}                           
                        </td>
                    </ng-container>
                       <ng-container matColumnDef="file2_remarks">
                        <th mat-header-cell *matHeaderCellDef>Remarks</th>
                        <td mat-cell *matCellDef="let file">
                            {{ file.file2_remarks  }}                           
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="form-actions">
        <button mat-raised-button color="primary" type="submit" (click)="onCancel()">Close</button>
    </div>
</mat-dialog-actions>